var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dialogos-app',{ref:"dialogos",attrs:{"dialogos":_vm.dialogos,"atrasVisible":false,"adelanteVisible":false}}),_c('actividad-unica-resp-app',{attrs:{"preguntas":require('../../assets/Modulo 2/diapositiva-18.json')},on:{"resultado":_vm.validarResultado,"reintentar":function($event){return _vm.$refs.dialogos.saltarAlDialogo(0)}}}),_c('audio-player',{ref:"audioPlayer",attrs:{"autoplay":true,"audios":[
  'Modulo 1/AUDIO 12',
  'Modulo 1/AUDIO 15',
  'Modulo 1/AUDIO 14',
  'Modulo 1/AUDIO 13.2',
  'Modulo 1/AUDIO 13.1',
  'Modulo 1/AUDIO 15.1' ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }